import React from "react"
import PropTypes from "prop-types"

import DecoratedTextField from "ui-DecoratedTextField"

export default class Text extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onFieldFlush: PropTypes.func.isRequired,
  }

  static defaultProps = { margin: "normal" }

  state = {}

  _handleChange = e => {
    this._needsFlush = true
    if (this.props.onChange) {
      this.props.onChange(e)

      if (e.isDefaultPrevented()) {
        return
      }
    }

    const event = this._parseEvent(e)
    this.props.onFieldChange(event)
  }

  _handleBlur = e => {
    this._flush(e)
  }

  _handleKeyDown = e => {
    if (e.keyCode == 13) {
      this._flush(e)
    }
  }

  _flush(e) {
    if (this._needsFlush) {
      this._needsFlush = false
      this.props.onFieldFlush(this._parseEvent(e))
    }
  }

  _parseEvent(e) {
    return this._parseValue(e.target.value)
  }

  _parseValue(value) {
    return { value, rawValue: value }
  }

  render() {
    const { onFieldChange, onFieldFlush, ...otherProps } = this.props

    return (
      <DecoratedTextField
        {...otherProps}
        onChange={this._handleChange}
        onBlur={this._handleBlur}
        onFocus={this._handleFocus}
        onKeyDown={this._handleKeyDown}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Field/Text.js